import React, { useMemo } from 'react'
import SmartLink from '@/component/Primitive/SmartLink'
import moment from 'moment/moment'
import styles from './EventLatestCTA.module.scss'
import { object, string } from 'prop-types'
import cx from 'classnames'
import Icon from '@/component/Primitive/Icon'
import YouTubeEmbed from '@/component/Primitive/YouTubeEmbed'

const PRE_TEXT = 'Global Events Program'
const BUTTON_TEXT = 'Attend Now'

const EventLatestCTA = ({ event, backgroundURL, textOverride, videoId }) => {
  const { brandColor, backgroundVideoId } = event
  const youTubeId = videoId || backgroundVideoId
  const hasBackground = !!(backgroundURL || youTubeId)

  const fromToDate = useMemo(() => {
    const { startDate, endDate } = event
    const startDateMoment = moment(startDate)
    const endDateMoment = moment(endDate)
    const isSameMonth = startDateMoment.month() === endDateMoment.month()
    const isSameDay =
      startDateMoment.format('Y MMMM D') === endDateMoment.format('Y MMMM D')

    if (isSameDay) {
      return startDateMoment.format('MMMM D')
    } else if (isSameMonth) {
      // Same month format: "May 28-29"
      return `${startDateMoment.format('MMMM D')}-${endDateMoment.format('D')}`
    } else {
      // Different month format: "May 28 - June 2"
      return `${startDateMoment.format('MMMM D')} - ${endDateMoment.format(
        'MMMM D'
      )}`
    }
  }, [event])

  const title = (
    <>
      Join us {event?.city ? `in ${event.city}` : null}
      <br />
      on {fromToDate}
    </>
  )

  return (
    <div
      className={styles.EventLatestCTA}
      style={brandColor && { '--color-theme--event': brandColor }}
    >
      <div
        className={cx(
          styles.EventLatestCTABackground,
          hasBackground && styles.EventLatestCTABackgroundMultiply
        )}
      >
        {!backgroundURL && youTubeId && (
          <div className={cx(styles.YoutubeEmbed)}>
            <YouTubeEmbed hideControls autoplay loop videoId={youTubeId} />
          </div>
        )}

        {backgroundURL && <img src={backgroundURL} alt="" />}
      </div>
      <span className={styles.EventLatestCTAAlert}>{PRE_TEXT}</span>
      <div className={styles.EventLatestCTAImage}>
        <img src={event?.darkLogoUrl || event?.lightLogoUrl} alt="" />
      </div>
      <SmartLink
        to={event?._fullUrl}
        className={cx(
          styles.EventLatestCTALink,
          hasBackground && styles.EventLatestCTALinkWhite
        )}
      >
        {textOverride || title}
      </SmartLink>
      <span className={styles.EventLatestCTAButton}>
        {BUTTON_TEXT}
        <Icon width={7} type="arrow-right" />
      </span>
    </div>
  )
}

EventLatestCTA.propTypes = {
  event: object,
  backgroundURL: string,
  textOverride: string,
  videoId: string
}

export default EventLatestCTA
